/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import MDHoverIconTooltip from "../../components/MDHoverIconTooltip";
export default function tableData() {
    function formatNumber(n) {
        if (!n) return '0.00';
        let parts = n.toString().split(".");

        // Apply comma as thousands separator
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // Ensure three decimal places
        if (parts[1]) {
            if (parts[1].length === 1) {
                parts[1] += "0"; // Add two zeros if there's only one digit
            } else if (parts[1].length > 3) {
                parts[1] = parts[1].substr(0, 2); // Truncate to three digits if longer
            }
            // No else needed for exactly three digits
        } else {
            parts[1] = "00"; // Add ".000" if there's no decimal part
        }

        return parts.join(".");
    }
    function monthConverter(inputDate) {
        const parts = inputDate.split("-");
        const month = parseInt(parts[0], 10);
        const year = parseInt(parts[1], 10);

        // Create a JavaScript Date object
        const date = new Date(year, month - 1, 1); // Note: Months are 0-based, so we subtract 1

        // Format the date as "MMM-yyyy" (e.g., "Oct-2023")
        const formattedDate = date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
        return formattedDate;
    }
    function readableFormatDate(dateStr){
        const dateObj = new Date(dateStr);

        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const month = months[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours() > 12 ? dateObj.getHours() - 12 : dateObj.getHours();
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');
        const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

        const formattedDate = `${month} ${day}, ${year}, ${hours}:${minutes}:${seconds} ${period}`;
        return formattedDate;
    }

    const booleanToStatus = (value) => (value ? "Enabled" : "Disabled");

    const trueFalseStringToStatus = (value) => (value === 'true' ? "Enabled" : "Disabled");


    function readableFormatDate2(dateStr) {
        const dateObj = new Date(dateStr);

        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are zero-indexed
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours();
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');
        // const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

        const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        return formattedDate;
    }


    return {
      groupConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Group Name Config", accessor: "grpConfigName", width: "20%", align: "left" },
        { Header: "Group Type", accessor: "grpType", width: "20%", align: "left" },
        { Header: "Group Id", accessor: "grpId", width: "20%", align: "left" },
        { Header: "Action", accessor: "action", width: "20%", align: "left" },
      ],
      deviceConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Terminal Brand", accessor: "terminalBrand", width: "10%", align: "left" },
        // { Header: "Terminal ID", accessor: "terminalId", width: "10%", align: "left" },
        { Header: "Serial Number", accessor: "serialNumber", width: "10%", align: "left" },
        { Header: "Device Status", accessor: "deviceStatus", width: "10%", align: "left" },
        { Header: "Action", accessor: "action", width: "10%", align: "left" },
        { Header: "Duplicate", accessor: "duplicate", width: "10%", align: "left" },
      ],
      controlConfigColumns: [
        { Header: "Control Name Config", accessor: "controlName", width: "10%", align: "left" },
        { Header: "Control Type", accessor: "controlType", width: "10%", align: "left" },
        { Header: "Control Id", accessor: "controlId", width: "10%", align: "left" },
        { Header: "Action", accessor: "action", width: "10%", align: "left" },
      ],
      hostConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", width: "10%", align: "left" },
        { Header: "Label", accessor: "label", width: "10%", align: "left" },
        { Header: "Manual Mode", accessor: "manualMode", width: "10%", align: "left" },
        { Header: "Host Type", accessor: "hostType", width: "10%", align: "left" },
        { Header: "Primary IP", accessor: "hostCommsName", width: "10%", align: "left" },
        { Header: "Primary IP Port", accessor: "primaryIpPort", width: "10%", align: "left" },
        { Header: "Secondary IP", accessor: "hostCommsBackup", width: "10%", align: "left" },
        { Header: "Secondary IP Port", accessor: "secondaryIpPort", width: "10%", align: "left" },
        { Header: "Tpdu", accessor: "tpdu", width: "10%", align: "left" },
        { Header: "Terminal Id", accessor: "terminalId", width: "10%", align: "left" },
        { Header: "Merchant Id", accessor: "merchantId", width: "10%", align: "left" },
        {
          Header: "Tle Enable",
          accessor: (row) => booleanToStatus(row.tieEnable),
          width: "10%",
          align: "left",
        },
        {
          Header: "Tle Loading Enable",
          accessor: (row) => booleanToStatus(row.tieKeyLoadingEnable),
          width: "10%",
          align: "left",
        },
        { Header: "Tle Bitmap", accessor: "theBitmap", width: "10%", align: "left" },
        { Header: "Settle Option", accessor: "settleOption", width: "10%", align: "left" },
        { Header: "Settle Time", accessor: "settleTime", width: "10%", align: "left" },
        {
          Header: "Card Configs",
          accessor: (row) => (
            <MDHoverIconTooltip
              icon="credit_card"
              values={row.cardConfigs || []}
              tooltipTitle="Card Configs"
              color="info"
            />
          ),
          width: "10%",
          align: "left",
        },
      ],
      cardConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", width: "10%", align: "left" },
        { Header: "Config Name", accessor: "configName", width: "10%", align: "left" },
        { Header: "Card Label", accessor: "cardLabel", width: "10%", align: "left" },
        { Header: "Low Prefix", accessor: "lowPrefix", width: "10%", align: "left" },
        { Header: "High Prefix", accessor: "highPrefix", width: "10%", align: "left" },
        { Header: "PAN Min Length", accessor: "panMinLength", width: "10%", align: "left" },
        { Header: "PAN Max Length", accessor: "panMaxLength", width: "10%", align: "left" },
        {
          Header: "Manual Entry Enabled",
          accessor: (row) => booleanToStatus(row.manualEntryEnabled),
          width: "10%",
          align: "left",
        },
        {
          Header: "Fallback Allow",
          accessor: (row) => booleanToStatus(row.fallback_allow),
          width: "10%",
          align: "left",
        },
        {
          Header: "LNHN Check Required",
          accessor: (row) => booleanToStatus(row.lnhnCheckRequired),
          width: "10%",
          align: "left",
        },
        {
          Header: "Preauthorize",
          accessor: (row) => booleanToStatus(row.preauthorize),
          width: "10%",
          align: "left",
        },
        {
          Header: "Doc Class CVM Limit",
          accessor: "docClassCVMLimit",
          width: "10%",
          align: "left",
        },
        {
          Header: "Doc Class Enabled",
          accessor: (row) => booleanToStatus(row.docClassEnabled),
          width: "10%",
          align: "left",
        },
        {
          Header: "PIN Bypass Enabled",
          accessor: (row) => booleanToStatus(row.pinBypassEnabled),
          width: "10%",
          align: "left",
        },
        {
          Header: "Receipt Customer PAN Mask",
          accessor: (row) => trueFalseStringToStatus(row.receiptCustomerPanMask),
          width: "10%",
          align: "left",
        },
        {
          Header: "Receipt Customer Expiry Date Mask",
          accessor: (row) => trueFalseStringToStatus(row.receiptCustomerExpiryDateMask),
          width: "10%",
          align: "left",
        },
        {
          Header: "Receipt Merchant PAN Mask",
          accessor: (row) => trueFalseStringToStatus(row.receiptMerchantPanMask),
          width: "10%",
          align: "left",
        },
        {
          Header: "Receipt Merchant Expiry Date Mask",
          accessor: (row) => trueFalseStringToStatus(row.receiptMerchantExpiryDateMask),
          width: "10%",
          align: "left",
        },
        //  { Header: "EMV Version Number", accessor: "evmVersionNumber", width: "10%", align: "left" },
        // { Header: "EMV Additional Capability", accessor: "evmAdditionalCapability", width: "10%", align: "left" },
        //  { Header: "Class TAC Online", accessor: "classTacOnline", width: "10%", align: "left" },
        // { Header: "Class Denial", accessor: "classDenial", width: "10%", align: "left" },
        // { Header: "Class Terminal Capability", accessor: "classTerminalCapability", width: "10%", align: "left" },
        {
          Header: "Fuel De54 Info",
          accessor: (row) => booleanToStatus(row.fuelDe54Info),
          width: "10%",
          align: "left",
        },
        {
          Header: "Fuel Print Info",
          accessor: (row) => booleanToStatus(row.fuelPrintInfo),
          width: "10%",
          align: "left",
        },
        { Header: "Fuel Logic", accessor: "fuelLogic", width: "10%", align: "left" },
        {
          Header: "Fuel Surcharge Percentage",
          accessor: "fuelSurchargePercentage",
          width: "10%",
          align: "left",
        },
        {
          Header: "Terminal Working key",
          accessor: "terminalWorkingKey",
          width: "10%",
          align: "left",
        },
      ],
      headerConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", width: "10%", align: "left" },
        {
          Header: "Logo",
          accessor: "reciptLogo",
          Cell: ({ row }) => {
            const src = row.original.reciptLogo;
            return src ? (
              <img src={src} alt="logo" style={{ height: 32, width: 32, objectFit: "contain" }} />
            ) : (
              <span style={{ color: "#888" }}>No logo</span>
            );
          },
        },
        {
          Header: "Receipt Header Line 1",
          accessor: "reciptHeaderLine1",
          width: "15%",
          align: "left",
        },
        {
          Header: "Receipt Header Line 2",
          accessor: "reciptHeaderLine2",
          width: "15%",
          align: "left",
        },
        {
          Header: "Receipt Header Line 3",
          accessor: "reciptHeaderLine3",
          width: "15%",
          align: "left",
        },
        {
          Header: "Receipt Header Line 4",
          accessor: "reciptHeaderLine4",
          width: "15%",
          align: "left",
        },
        {
          Header: "Host Reference",
          accessor: (row) => (
            <MDHoverIconTooltip
              icon="info"
              values={row.hostReferenceLabels || []}
              tooltipTitle="Host Reference"
              color="info"
            />
          ),
          width: "20%",
          align: "left",
        },
      ],
      installmentConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", align: "center" },
        { Header: "Number of Payments", accessor: "numberOfPayments", align: "left" },
        { Header: "Table No", accessor: "tableNo", align: "left" },
        { Header: "Risk Type", accessor: "riskType", align: "left" },
        { Header: "Reserved", accessor: "reserved", align: "left" },
        { Header: "Payment Plan", accessor: "paymentPlan", align: "left" },
        {
          Header: "Host Reference",
          accessor: (row) => (
            <MDHoverIconTooltip
              icon="info"
              values={row.hostReferenceLabels || []}
              tooltipTitle="Host Reference"
              color="info"
            />
          ),
          align: "left",
        },
        // if you’re adding action buttons
      ],
      currencyConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", align: "center" },
        { Header: "Currency Name", accessor: "currencyName", align: "left" },
        { Header: "Currency Code", accessor: "currencyCode", align: "left" },
        {
          Header: "Preauth Enabled",
          accessor: (row) => booleanToStatus(row.preauthEnabled),
          align: "center",
        },
        { Header: "Cless CVM Limit", accessor: "classCVMLimit", align: "right" },
        { Header: "Cless Floor Limit", accessor: "classFloorLimit", align: "right" },
        { Header: "Cless Transaction Limit", accessor: "classTransactionLimit", align: "right" },
        {
          Header: "Host Reference",
          accessor: (row) => (
            <MDHoverIconTooltip
              icon="info"
              values={row.hostReferenceLabels || []}
              tooltipTitle="Host Reference"
              color="info"
            />
          ),
          align: "left",
        },
      ],

      evmParamsConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", align: "center" },
        { Header: "EMV Scheme", accessor: "evmScheme", align: "left" },
        { Header: "EMV AID", accessor: "evmAid", align: "left" },
        { Header: "EMV TAC Default", accessor: "evmTacDefault", align: "left" },
        { Header: "EMV TAC Denial", accessor: "evmTacDenial", align: "left" },
        { Header: "EMV TAC Act Code", accessor: "evmTacActCode", align: "left" },
        { Header: "EMV Threshold Value", accessor: "evmThresholdValue", align: "right" },
        // { Header: "EMV Target Percentage", accessor: "evmTargetPercentage", align: "right" },
        //  { Header: "EMV Max Target Percentage", accessor: "evmMaxTargetPer", align: "right" },
        { Header: "EMV Default DDOL", accessor: "evmDefaultDdol", align: "left" },
        { Header: "EMV Default TDOL", accessor: "evmDefaultTdol", align: "left" },
        { Header: "EMV App Version", accessor: "evmAppVersion", align: "left" },
        { Header: "EMV Acquirer Identifier", accessor: "evmAcqIdentifier", align: "left" },
        { Header: "EMV Floor Limit", accessor: "evmFloorLimit", align: "right" },
        // { Header: "EMV Txn Category Code", accessor: "evmTxnCategoryCode", align: "center" },
        //{ Header: "EMV AID Tax Type", accessor: "evmAidTaxType", align: "left" },
        //{ Header: "EMV Card Label", accessor: "evmCardLabel", align: "left" },
        { Header: "EMV Trans Type", accessor: "evmTransType", align: "center" },
        { Header: "EMV Trans Currency", accessor: "evmTransCurrency", align: "left" },
        { Header: "EMV Trans Capability", accessor: "evmTransCapability", align: "left" },
        // { Header: "EMV Trans Terminal ID", accessor: "evmTransTerminalId", align: "left" },
        { Header: "EMV Txn Country Code", accessor: "evmTxnCountryCode", align: "left" },
        { Header: "EMV Terminal Type", accessor: "evmTerminalType", align: "center" },
        { Header: "EMV Terminal Risk Mgmt Data", accessor: "evmTerminalRiskMg", align: "left" },
        { Header: "EMV Version No", accessor: "evmVersionNo", align: "left" },
        {
          Header: "EMV Additional Capabilities",
          accessor: "evmAdditionalCapability",
          align: "left",
        },
        { Header: "Cless TAC Default", accessor: "classTacDefault", align: "left" },
        { Header: "Cless TAC Online", accessor: "classTacOnline", align: "left" },
        { Header: "Cless Denial", accessor: "classDenial", align: "left" },
        { Header: "Cless Terminal Capability", accessor: "classTerminalCapability", align: "left" },
      ],
      capkConfigColumns: [
        { Header: "S.No", accessor: "serial", width: "5%", align: "center", Cell: ({ row }) => row.index + 1 },
        { Header: "Action", accessor: "action", align: "center" },
        { Header: "CAPK Scheme", accessor: "capkScheme", align: "left" },
        { Header: "RID", accessor: "rid", align: "left" },
        { Header: "CAPK Index", accessor: "capkIndex", align: "left" },
        { Header: "Module", accessor: "module", align: "left" },
        { Header: "Exponent", accessor: "exponent", align: "left" },
        { Header: "Checksum", accessor: "checksum", align: "left" },
        { Header: "Algorithm Ind", accessor: "algorithmInd", align: "center" },
        { Header: "Hash Ind", accessor: "hashInd", align: "center" },
      ],
    };
}
